import { WebsiteSliderTypeEnum } from '@onArte/shared/database/enums';
import { AttachmentInterface, SliderButtonSettingsInterface } from '@onArte/shared/interfaces/common';

import { AbstractSliderDTO } from './abstractSlider.dto';
import { SliderItemData } from './sliderItemData.interface';

export class SliderWithItemDataDTO extends AbstractSliderDTO {
  constructor(
    id: number,
    type: WebsiteSliderTypeEnum,
    image: AttachmentInterface,
    header: string,
    buttonSettings: SliderButtonSettingsInterface | null,
    secondButtonSettings: SliderButtonSettingsInterface | null,
    description: string | null,
    public linkedItem?: SliderItemData,
  ) {
    super(id, type, image, header, buttonSettings, secondButtonSettings, description);
  }
}
